<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wg5oby/media/FC-9781398499584.jpg?1695340671774" alt="This image is the cover for the book The Illusion of Guilt"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Illusion of Guilt
      </h1>
      <p class="bookDescription body article font2">
        <p>Roy’s life was not going well. He was clever, very clever, but his boss didn’t like him and finding other jobs in the computer industry at the ripe old age of forty-five could be difficult. He had bought a house with his girlfriend, but she was leaving him because he was “too nice”. He would have the debts of the house plus old debts that he was still repaying. Then there was Rosemary, but she seemed preoccupied with her stalker who had threatened Roy, grabbing by the throat on one occasion. Would he end up like his friend Keith who drove to the top of a car park and jumped off? However, Roy had done something remarkable: he had saved the life of a man at one of his favourite hiking spots. He didn’t know what this would mean at the time. Then he realised there were other options for the stalker and his boss. What would he do? Would he feel guilt or was guilt just an illusion?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephen Jay
      </h2>
      
      <p class="authorDescription body article">Stephen Jay retired from a successful career in the computer profession and started writing short stories and novellas. The Illusion of Guilt is his first novel and features a computer professional. Stephen recently moved to Devon and enjoys going for long walks where he clarifies his plots. He also enjoys reading, composing music, and hunting for antiques.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?349c70e8